import { RefObject, useState } from "react";
import { useProductFruitsApi } from "react-product-fruits";
import {
    hideChecklistError,
    showChecklistContainer,
    showChecklistError,
} from "./ProductFruitsChecklistContainer";

interface IuseIwProductFruitsParams {
    deps?: any[];
}

const QUICK_START_TOUR_ID = process.env.NEXT_PUBLIC_QUICK_START_TOUR_ID;
const USE_CANVAS_TOUR_ID = process.env.NEXT_PUBLIC_USE_CANVAS_TOUR_ID;
const CREATE_INTERVIEW_TOUR_ID =
    process.env.NEXT_PUBLIC_CREATE_INTERVIEW_TOUR_ID;
const CREATE_INSIGHT_TOUR_ID = process.env.NEXT_PUBLIC_CREATE_INSIGHT_TOUR_ID;
const CREATE_TEMPLATE_TOUR_ID = process.env.NEXT_PUBLIC_CREATE_TEMPLATE_TOUR_ID;
const IN_APP_TOUR_CHECKLIST_ID =
    process.env.NEXT_PUBLIC_IN_APP_TOUR_CHECKLIST_ID;
const IN_APP_TOUR_CHECKLIST_FETCH_ERROR = "Couldn't fetch help guide for you!";

const useIwProductFruits = (params: IuseIwProductFruitsParams = {}) => {
    const { deps = [] } = params;
    const [apiInstance, setApiInstance] = useState<any>(null);

    const getApiInstance = () => {
        if (!apiInstance) {
            console.error("Product Fruits API instance isn't initialized");
        }

        return apiInstance;
    };

    const startQuickStartTour = () => {
        const api = getApiInstance();

        if (!!api) {
            api.tours.tryStartTour(QUICK_START_TOUR_ID);
        }
    };

    const startUseCanvasTour = () => {
        const api = getApiInstance();

        if (!!api) {
            api.tours.tryStartTour(USE_CANVAS_TOUR_ID);
        }
    };

    const startCreateInterviewTour = () => {
        const api = getApiInstance();

        if (!!api) {
            api.tours.tryStartTour(CREATE_INTERVIEW_TOUR_ID);
        }
    };

    const startCreateInsightTour = () => {
        const api = getApiInstance();

        if (!!api) {
            api.tours.tryStartTour(CREATE_INSIGHT_TOUR_ID);
        }
    };

    const startCreateTemplateTour = () => {
        const api = getApiInstance();

        if (!!api) {
            api.tours.tryStartTour(CREATE_TEMPLATE_TOUR_ID);
        }
    };

    const showInAppTourChecklist = (containerRef: RefObject<HTMLElement>) => {
        const api = getApiInstance();

        if (!!api) {
            try {
                api.checklists.injectToElement(
                    IN_APP_TOUR_CHECKLIST_ID,
                    containerRef.current
                );
                hideChecklistError(containerRef.current);
            } catch {
                showChecklistError(
                    containerRef.current,
                    IN_APP_TOUR_CHECKLIST_FETCH_ERROR
                );
            }

            showChecklistContainer(containerRef.current);
        }
    };

    useProductFruitsApi(
        (api) => {
            setApiInstance(api);
        },
        [...deps]
    );

    return {
        IwProductFruitsApi: apiInstance,
        startQuickStartTour,
        showInAppTourChecklist,
        startUseCanvasTour,
        startCreateInterviewTour,
        startCreateInsightTour,
        startCreateTemplateTour,
    };
};

export default useIwProductFruits;
